import { render } from "./HillScene.vue?vue&type=template&id=7358ce8d&scoped=true"
import script from "./HillScene.vue?vue&type=script&lang=js"
export * from "./HillScene.vue?vue&type=script&lang=js"

import "./HillScene.vue?vue&type=style&index=0&id=7358ce8d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7358ce8d"]])

export default __exports__